import Head from 'next/head';
import PropTypes from 'prop-types';
import BatchesListing from '@cont/SeeAll/BatchesListing';
import { fetchBatches } from '@actions/batches';
import { fetchTopologyInfo } from '@actions/topologies';
import subGoalSchema from '@seo/goal/subGoal';
import SEO from '@seo/index';
import { useSetSelectedNav } from '@stores/sidenav';
import plusNavBarItems from '@layout/NavBar/PlusNavBar/plusNavBarItems';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const BatchListingPages = ({ goalInfo }) => {
  const { title, description, uid, slug, ogImage } = goalInfo || {};
  const metaTitle = `Batches / ${title}  / Unacademy`;
  const metaDescription =
    description ||
    'Prepare for examinations and take any number of courses from various topics on Unacademy - an education revolution';
  const canonicalURL = `https://unacademy.com/goal/${slug}/${uid}/batches`;
  useSetSelectedNav(plusNavBarItems.BROWSE);
  return (
    <>
      <SEO
        title={metaTitle}
        description={metaDescription}
        url={canonicalURL}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          images: [
            {
              url: ogImage
            }
          ],
          url: canonicalURL
        }}
        schema={subGoalSchema({
          goal: goalInfo,
          description: metaDescription,
          subGoal: { name: 'batches', link: 'classes' }
        })}
      />
      <Head>
        <title>{metaTitle}</title>
        <link rel="canonical" href={canonicalURL} />
      </Head>
      <BatchesListing />
    </>
  );
};

BatchListingPages.pageInfo = {
  isMWebSupported: true,
  name: 'All Batches Page',
  layoutOptions: {
    showPlusNav: true
  },
  seeAll: true,
  isCMSMeta: true
};

export default BatchListingPages;

BatchListingPages.getInitialProps = setupInitialProps(
  async ({ store, query, isServer }) => {
    const { goalUID } = query;
    const promises = [];
    promises.push(store.dispatch(fetchBatches(goalUID)));
    if (isServer) promises.push(store.dispatch(fetchTopologyInfo(goalUID)));
    await Promise.all(promises);
    return { isServer, goalInfo: store.getState().topologies.data[goalUID] };
  },
  BatchListingPages.pageInfo
);

BatchListingPages.propTypes = {
  goalInfo: PropTypes.objectOf(PropTypes.any).isRequired
};
BatchListingPages.Layout = Layout;
BatchListingPages.Wrapper = PageReduxProvider;
